import { render, staticRenderFns } from "./InterventionSetupModal.vue?vue&type=template&id=65c2b53f"
import script from "./InterventionSetupModal.vue?vue&type=script&lang=ts"
export * from "./InterventionSetupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports